import {
  createContext,
  useContext,
  useState,
  useEffect,
  type ReactNode,
} from "react";
import { getStoredAuth, clearAuth, type MatrixAuth } from "./matrix-client";

interface AuthContextType {
  auth: MatrixAuth | null;
  isLoading: boolean;
  logout: () => void;
  refresh: () => void;
}

const AuthContext = createContext<AuthContextType>({
  auth: null,
  isLoading: true,
  logout: () => {},
  refresh: () => {},
});

export function AuthProvider({ children }: { children: ReactNode }) {
  const [auth, setAuth] = useState<MatrixAuth | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const refresh = () => {
    setAuth(getStoredAuth());
  };

  useEffect(() => {
    setAuth(getStoredAuth());
    setIsLoading(false);
  }, []);

  const logout = () => {
    clearAuth();
    setAuth(null);
  };

  return (
    <AuthContext.Provider value={{ auth, isLoading, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
